import React from 'react'

export const IconChevronRightSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M9 18.962l8.101-6.481L9 6v2.561l4.9 3.92L9 16.4z"
      ></path>
    </svg>
  )
}
